/**
 * Created by AlexanderC on 5/22/15.
 *
 * Bootstrap file loaded by npm as main
 */

'use strict';

var _Interface = require('./OOP/Interface');

var _Runtime = require('./AWS/Lambda/Runtime');

var _Region = require('./AWS/Region');

var _Service = require('./AWS/Service');

var _Policy = require('./AWS/IAM/Policy');

var _Factory = require('./AWS/IAM/Factory');

var _ObjectStorage = require('./Generic/ObjectStorage');

var _UniversalRequire = require('./Generic/UniversalRequire');

var _ObjectVector = require('./Generic/ObjectVector');

var _MethodsProxy = require('./Generic/MethodsProxy');

var _Exception = require('./Exception/Exception');

var _MethodsNotImplementedException = require('./Exception/MethodsNotImplementedException');

var _InvalidArgumentException = require('./Exception/InvalidArgumentException');

var _DatabaseOperationException = require('./Exception/DatabaseOperationException');

var _ResourceNotFoundException = require('./Exception/ResourceNotFoundException');

var _Sandbox = require('./Runtime/Sandbox');

var _Helper = require('./HTTP/Helper');

module.exports = {
  IS_DEV_SERVER: global.__DEEP_DEV_SERVER || false,
  Exception: {
    Exception: _Exception.Exception,
    InvalidArgumentException: _InvalidArgumentException.InvalidArgumentException,
    MethodsNotImplementedException: _MethodsNotImplementedException.MethodsNotImplementedException,
    DatabaseOperationException: _DatabaseOperationException.DatabaseOperationException,
    ResourceNotFoundException: _ResourceNotFoundException.ResourceNotFoundException
  },
  HTTP: {
    Helper: _Helper.Helper
  },
  Runtime: {
    Sandbox: _Sandbox.Sandbox
  },
  OOP: {
    Interface: _Interface.Interface
  },
  Generic: {
    ObjectStorage: _ObjectStorage.ObjectStorage,
    ObjectVector: _ObjectVector.ObjectVector,
    MethodsProxy: _MethodsProxy.MethodsProxy,
    UniversalRequire: _UniversalRequire.UniversalRequire
  },
  AWS: {
    Region: _Region.Region,
    Service: _Service.Service,
    IAM: {
      Factory: _Factory.Factory,
      Policy: _Policy.Policy
    },
    Lambda: {
      Runtime: _Runtime.Runtime
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ../~/deep-core/lib.compiled/bootstrap.js
// module id = 3
// module chunks = 0